"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NormalFilter = exports.Footer = exports.AdvancedFilter = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _get = _interopRequireDefault(require("lodash/get"));
var _formik = require("formik");
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));
var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));
var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));
var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));
var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));
var _SearchOperators = _interopRequireDefault(require("../SearchOperators"));
var _Button = _interopRequireDefault(require("../Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Container = _interopRequireDefault(require("./Container"));
var _styles = require("@material-ui/core/styles");
require("./index.css");
var _excluded = ["name", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    icon: {
      fontSize: '4rem'
    }
  };
});
var fieldPrefix = 'criteria';
var Input = function Input(_ref) {
  var name = _ref.name,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleOnChange = function handleOnChange(value, fieldProps) {
    var field = fieldProps.field,
      form = fieldProps.form;
    form.setFieldValue(field.name, value);
  };
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(fieldProps) {
      return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, rest, {
        className: className,
        defaultValue: (0, _get["default"])(fieldProps, 'field.value', '').toString(),
        onChange: function onChange(e) {
          return handleOnChange(e.target.value, fieldProps);
        }
      }));
    }
  });
};
var Filter = function Filter(_ref2) {
  var onAddAction = _ref2.onAddAction,
    _ref2$actions = _ref2.actions,
    actions = _ref2$actions === void 0 ? [] : _ref2$actions,
    filter = _ref2.filter,
    footer = _ref2.footer;
  var classes = useStyles();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-around h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center flex-1"
  }, filter, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap mt-6"
  }, actions, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "text-lg font-semibold text-gray-light",
    onClick: onAddAction
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2 text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
    classes: {
      root: classes.icon
    }
  })), actions.length < 1 && t('settings.filter.action.button')))), footer));
};
var NormalFilter = exports.NormalFilter = function NormalFilter(_ref3) {
  var criterias = _ref3.criterias,
    activeCriteria = _ref3.activeCriteria,
    onChangeCriteria = _ref3.onChangeCriteria;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl font-semibold text-dark"
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('settings.filter.normal.text'), ' ', /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "font-semibold text-primary",
    onClick: onChangeCriteria
  }, (0, _get["default"])(criterias, "".concat(activeCriteria, ".label"), 'From'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Input, {
    name: "".concat(fieldPrefix, ".").concat(activeCriteria),
    spellCheck: "false",
    autoComplete: "off",
    className: "font-semibold bg-transparent border-b-4 rounded-none sm:w-3/5 border-primary text-primary",
    style: {
      maxWidth: 800
    }
  })));
};
var AdvancedFilter = exports.AdvancedFilter = function AdvancedFilter() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShowModal = _useState2[0],
    setModal = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "advanced-filter"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl font-semibold text-dark"
  }, t('settings.filter.advanced.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-light"
  }, t('settings.filter.advanced.note'), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: "Help"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mx-2 cursor-pointer",
    onClick: function onClick() {
      return setModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    fontSize: "small"
  })))), /*#__PURE__*/_react["default"].createElement("table", {
    className: "pb-6 border-b w-50vw"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", {
    key: 'from'
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "key"
  }, "From"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "value"
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    name: "".concat(fieldPrefix, ".from"),
    className: "w-full"
  }))), /*#__PURE__*/_react["default"].createElement("tr", {
    key: 'to'
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "key"
  }, "To"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "value"
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    name: "".concat(fieldPrefix, ".to"),
    className: "w-full"
  }))), /*#__PURE__*/_react["default"].createElement("tr", {
    key: 'subject'
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "key"
  }, "Subject"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "value"
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    name: "".concat(fieldPrefix, ".subject"),
    className: "w-full"
  }))), /*#__PURE__*/_react["default"].createElement("tr", {
    key: 'words'
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "key"
  }, "Has the Words"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "value"
  }, /*#__PURE__*/_react["default"].createElement(Input, {
    name: "".concat(fieldPrefix, ".query"),
    className: "w-full"
  }))))), /*#__PURE__*/_react["default"].createElement(_SearchOperators["default"], {
    isOpen: isShowModal,
    toggle: function toggle() {
      return setModal(!isShowModal);
    }
  }));
};
var Footer = exports.Footer = function Footer(_ref4) {
  var note = _ref4.note,
    _ref4$matched = _ref4.matched,
    matched = _ref4$matched === void 0 ? 0 : _ref4$matched,
    _ref4$enableToSubmit = _ref4.enableToSubmit,
    enableToSubmit = _ref4$enableToSubmit === void 0 ? true : _ref4$enableToSubmit,
    isAdvanced = _ref4.isAdvanced,
    setAdvance = _ref4.setAdvance,
    onSubmit = _ref4.onSubmit,
    onCancel = _ref4.onCancel,
    onPreview = _ref4.onPreview;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2 text-xs italic text-gray-light"
  }, note), !!matched && /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2 font-semibold text-gray-light"
  }, matched, " message", matched > 1 ? 's' : '', " found.", ' ', /*#__PURE__*/_react["default"].createElement("button", {
    className: "font-semibold text-primary",
    onClick: onPreview
  }, t('settings.filter.preview.hint'))), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "execute",
    render: function render(_ref5) {
      var field = _ref5.field,
        form = _ref5.form;
      return /*#__PURE__*/_react["default"].createElement("label", {
        className: "my-2 font-semibold cursor-pointer select-none text-gray-light hover:text-gray-medium"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        name: field.name,
        className: "hidden",
        onChange: function onChange(e) {
          return form.setFieldValue(field.name, e.target.checked);
        }
      }), field.value ? /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], null) : /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
        className: "ml-4 !text-gray-light"
      }, t('settings.filter.applyFilter')));
    }
  }), !isAdvanced && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex items-center my-2 font-semibold text-gray-light hover:text-primary",
    onClick: setAdvance
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-4"
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], null)), t('settings.filter.advanced.footerHint'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-10"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "button",
    color: "secondary",
    className: "w-56 mr-4",
    onClick: onCancel
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    disabled: !enableToSubmit,
    className: "w-56",
    onClick: onSubmit
  }, t('button.submit'))));
};
var _default = exports["default"] = Filter;
//# sourceMappingURL=Main.js.map